// src/WayneAIPlatformFrontend/src/hooks/useMultistreamSummary.ts
import { useChatStream } from '@/stores/chatStream.store';
import { useMemo } from 'react';

export interface MultistreamSummary {
  count: number;
  totalBytes: number;
  anyActive: boolean;
}

export function useMultistreamSummary(): MultistreamSummary {
  const map = useChatStream((s) => s.streamingByAgentId);
  return useMemo(() => {
    const buffers = Object.values(map).filter(Boolean) as Array<{ bytes: number }>;
    return { count: buffers.length, totalBytes: buffers.reduce((n, b) => n + b.bytes, 0),
             anyActive: buffers.length > 0 };
  }, [map]);
}
